import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TestService } from '../TestService';

// Test mutations
export const useCreateTest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => TestService.newTest(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tests'] });
    },
  });
};

export const useUpdateTest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => TestService.updateTest(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['tests'] });
      queryClient.invalidateQueries({ queryKey: ['test', id] });
    },
  });
};

// TestGroup mutations
export const useCreateTestGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => TestService.newTestGroup(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['test-groups'] });
    },
  });
};

export const useUpdateTestGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => TestService.updateTestGroup(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['test-groups'] });
      queryClient.invalidateQueries({ queryKey: ['test-group', id] });
    },
  });
};

// TestCollection mutations
export const useCreateTestCollection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => TestService.newTestCollection(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['test-collections'] });
    },
  });
};

export const useUpdateTestCollection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => TestService.updateTestCollection(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['test-collections'] });
      queryClient.invalidateQueries({ queryKey: ['test-collection', id] });
    },
  });
};
